import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { DynamicScriptLoaderService } from 'src/app/Services/dynamic-script-loader.service';

declare var $: any;
@Component({
  selector: 'ppa-secure',
  templateUrl: './secure.component.html',
  styleUrls: ['./secure.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SecureComponent implements OnInit, AfterViewInit {

  //controlar pelo GSI/Token/etc
  administrador = false;

  constructor(private dynamicScriptLoader: DynamicScriptLoaderService) {
  }

  ngOnInit() {
    this.dynamicScriptLoader.load('app').then(() => {
      this.dynamicScriptLoader.load('layout-vertical', 'quick-sidebar', 'quick-nav', 'image-map-resizer')
    });
  }

  ngAfterViewInit(): void {
    $(document).ready(function () {
      $('map').imageMapResize();
    });
  }
}
